<template>
    <div class="users box-white-wrapper">
        <vs-table search :data="creditLines" pagination max-items="10">
            <template slot="header">
                <vs-button color="primary" @click="openModal()" type="border" icon="library_add">Crear Linea de Cr&eacute;dito</vs-button>
            </template>
            <template slot="thead">
                <vs-th sort-key="code">C&oacute;digo </vs-th>
                <vs-th sort-key="name">Nombre</vs-th>
                <vs-th sort-key="description"> Descripci&oacute;n</vs-th>
                <vs-th sort-key="term"> Plazo</vs-th>
                <vs-th sort-key="id" class=""></vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].code"> {{data[indextr].code }} </vs-td>
                    <vs-td :data="data[indextr].name"> {{data[indextr].name}} </vs-td>
                    <vs-td :data="data[indextr].description"> {{data[indextr].description}} </vs-td>
                    <vs-td :data="data[indextr].term"> {{data[indextr].term}} </vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions">
                            <a href="javascript:void(0)" class="" @click="editCreditLine(data[indextr].code)"><feather type="edit-2"/></a>
                            <a href="javascript:void(0)" class="" @click="openConfirmDialog(data[indextr].code)" v-if="data[indextr].st01Code === 1 "><feather type="trash"/></a>
                            <a href="javascript:void(0)" class="" @click="openConfirmDialog(data[indextr].code)" v-if="data[indextr].st01Code === 2 "><feather type="check-circle"/></a>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
         <transition name="fade">
            <modalBasic :show="modalActive">
                <div class="modal-header" slot="modal-header">{{ modalTitle }}</div>
                <div class="modal-body limit-body" slot="modal-body">
                    <form>
                        <div :class="['form-input', {'has-error': $v.creditLine.code.$error }]" v-if="!isUpdating">
                            <vs-input label="Código" v-model.trim="$v.creditLine.code.$model"/>
                            <span class="error-text" v-if="$v.creditLine.code.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.creditLine.name.$error }]" >
                            <vs-input label="Nombre" v-model.trim="$v.creditLine.name.$model"/>
                            <span class="error-text" v-if="$v.creditLine.name.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.creditLine.term.$error }]" >
                            <vs-input label="Plazo" v-model.trim="$v.creditLine.term.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="$v.creditLine.term.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.creditLine.description.$error }]" >
                            <vs-input label="Descripción" v-model.trim="$v.creditLine.description.$model"/>
                            <span class="error-text" v-if="$v.creditLine.description.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer" slot="modal-footer">
                    <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                    <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                        @click="handleRequestCreditLine" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                </div>
            </modalBasic>
         </transition>
    </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import { required } from 'vuelidate/lib/validators'
import modalBasic from '@/components/Modal/Basic.vue'
import CreditLineModel from '@/models/CreditLineModel'
import CreditDataService from "@/services/CreditDataService"

export default {
    name: 'CreditLine',
    mixins: [helper],
    components: {
      modalBasic,
    },
    data() {
      return {
        creditLines: [],
        creditLine: new CreditLineModel(),
        currentx: 5,
        isUpdating: false,
        confirmStatus: false,
        modalTitle: 'Nueva Linea de Crédito',
        modalActive: false,
      }
    },
    validations: {
        creditLine: {
            code: { required },
            name: { required },
            description: { required },
            term: { required }
        }
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted () {
      this.retrieveCreditLines()
    },
    methods:{
        retrieveCreditLines() {
            CreditDataService.get('/creditLines')
            .then(response => {
                this.creditLines = response.data;
                this.$Progress.finish()
            })
            .catch(e => {
                console.log(e);
                this.$Progress.finish()
                this.$vs.notify({title:'Error!',text:'Error obteniendo las lineas de credito!',color:'danger',icon:'error_outline'})
            });
        },
        openModal () {
          this.modalActive = true
          this.isUpdating  = false
          this.creditLine    = new CreditLineModel()
          this.$v.$reset()
        },
        closeModal () {
          this.modalTitle  = 'Nueva Linea de Crédito'
          this.modalActive = false
          this.creditLine    = new CreditLineModel()
          this.$v.$reset()
        },
        editCreditLine (id) {
            this.modalTitle  = 'Editar Linea de Crédito'
            this.modalActive = true
            this.creditLine  = this.searchCreditLine (id)
            this.isUpdating  = true
        },
        openConfirmDialog(_id){
            this.creditLine    = this.searchCreditLine (_id)
            let modeText = this.creditLine.status.code == 1 ? 'desactivar al' : 'activar el'
            this.$vs.dialog({
                type:'confirm',
                title: `¡Atención!`,
                color:'',
                cancelText: 'No',
                acceptText: 'Si',
                iconPack:'home',
                text: '¿Estas seguro de '+modeText+' la linea de crédito?',
                accept:this.changeCreditLineStatus
            })
        },
        changeCreditLineStatus(){
            this.creditLine.status.code = this.creditLine.status.code == 1 ? 2 : 1
            CreditDataService.update('/creditLines', this.creditLine)
            .then( () => {
                this.confirmStatus = false
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.$vs.notify({title:'Información',text:'La linea de crédito fue actulizada exitosamente!',color:'success',icon:'check'})
                this.retrieveCreditLines()
            })
            .catch(e => {
                console.log(e)
                this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                this.confirmStatus = false
                this.$vs.notify({title:'Información',text:'Error actulizando el estado del usuario',color:'danger',icon:'error_outline'})                
            });
        },
        handleRequestCreditLine(){
            this.$v.$touch()
            if (this.$v.$invalid) return;
            if (!this.isUpdating) {
                this.saveCreditLine()
            } else {
                this.updateCreditLine()
            }
        },
        saveCreditLine(){
            this.loadingProgress ('#btnConfirm')
            this.confirmStatus = true
            CreditDataService.new('/creditLines', this.creditLine)
            .then(response => {
                console.log(response)
                this.confirmStatus = false
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.modalActive = false
                this.$vs.notify({title:'Información',text:'La linea de crédito fue creada exitosamente!',color:'success',icon:'check'})
                this.creditLine    = new CreditLineModel()
                this.$v.$reset()
                this.creditLines.push(response.data.result)
            })
            .catch(e => {
                console.log(e)
                this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                this.confirmStatus = false
                this.$vs.notify({title:'Información',text:'Error creando la linea de crédito.',color:'danger',icon:'error_outline'})                
            });
        
        },
        updateCreditLine(){
            this.loadingProgress ('#btnConfirm')
            this.confirmStatus = true
            CreditDataService.update('/creditLines', this.creditLine)
            .then(response => {
                console.log(response)
                this.confirmStatus = false
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.modalActive = false
                this.$vs.notify({title:'Información',text:'La linea de crédito fue actualizada exitosamente!',color:'success',icon:'check'})
                this.creditLine  = new CreditLineModel()
                this.$v.$reset()
                this.retrieveCreditLines()
            })
            .catch(e => {
                console.log(e)
                this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                this.confirmStatus = false
                this.$vs.notify({title:'Información',text:'Error actualizando la linea de crédito.',color:'danger',icon:'error_outline'})                
            });
        
        },
        
        searchCreditLine (_code) {
            let obj = this.creditLines.filter((item) => {
              return _code === item.code
            })
            obj =  obj[0]
            let creditLine = new CreditLineModel(
                obj.code,
                obj.name,
                obj.description,
                obj.term,
                obj.rate,
                { code: obj.st01Code }
            )
            return creditLine
        },
    }
}
</script>
